import config from '@/config'
export  default [
  {
    title: "媒体组件",
    modules: [
      {
        icon: "FileTextOutlined",
        name: "背景图",
        type:'header',
        hidden:true,
        defaultData:{
          type:'header',
          name:'背景图',
          data:[],
          params:{
            imgUrl:''
          }
        }
      },
      {
        icon: "FundOutlined",
        name: "轮播图",
        type:'banner',
        defaultData:{
          type:'banner',
          name:'图片轮播',
          data:[
            {imgUrl:'',linkUrl:""},
          ],
          params:{
            interval: "2800"
          },
          style:{
            btnColor: "#ffffff",
            btnShape: "round"
          }
        }
      },
      {
        icon: "WindowsOutlined",
        name: "图片橱窗",
        type:'windows',
        defaultData:{
          type:'windows',
          name:'图片橱窗',
          data:[
            {imgUrl:"",linkUrl:""},
          ],
          params:{},
          style:{
            class:'full',
            backgroundColor: "#ffffff",
            paddingTB:0,
            paddingLR:0,
          }
        }
      },
      // {
      //   icon: "FileTextOutlined",
      //   name: "积分任务",
      //   type:'task',
      //   defaultData:{
      //     type:'task',
      //     name:'积分任务',
      //     data:[
      //       {name:'',describe:'',imgUrl:"",linkUrl:""}
      //     ],
      //     params:{
      //       show:true,
      //       taskTitle:'任务标题'
      //     },
      //     style:{}
      //   }
      // }
    ],
  }
]